"use client";
interface EnquireNowButtonProps {
  buttonText?: string;
}

export default function EnquireNowButton({
  buttonText = "Enquire Now",
}: EnquireNowButtonProps) {
  type OpenKind = "enquiry" | "brochure";

  const toggleModal = (type?: OpenKind) => {
    const modal = document.getElementById("contact-modal");

    if (!modal) return;

    if (type) {
      sessionStorage.setItem("contactModalType", type);
      window.dispatchEvent(new Event("contactModalOpen"));
      modal.classList.add("active");
    } else {
      sessionStorage.removeItem("contactModalType");
      window.dispatchEvent(new Event("contactModalOpen"));
      modal.classList.remove("active");
    }
  };

  return (
    <button
      aria-label={buttonText}
      className="group text-[#fff] hover:text-[#fff] bg-[#000] rounded-[50px] px-[20px] md:px-[25px] py-[8px] md:py-[12px] w-fit gap-[15px] flex items-center justify-between transition-all duration-300 hover:bg-[#AF8E43] cursor-pointer"
      onClick={() => toggleModal("enquiry")}
    >
      {buttonText}

      <svg
        width="12"
        height="12"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform duration-300 group-hover:rotate-45"
      >
        <path
          d="M15.435 1.56497C15.435 1.01269 14.9873 0.564971 14.435 0.564971L5.43503 0.564972C4.88274 0.564971 4.43503 1.01269 4.43503 1.56497C4.43503 2.11726 4.88274 2.56497 5.43503 2.56497L13.435 2.56497L13.435 10.565C13.435 11.1173 13.8827 11.565 14.435 11.565C14.9873 11.565 15.435 11.1173 15.435 10.565L15.435 1.56497ZM1 15L1.70711 15.7071L15.1421 2.27208L14.435 1.56497L13.7279 0.857865L0.292893 14.2929L1 15Z"
          fill="#fff"
          className="group-hover:fill-[#fff]"
        />
      </svg>
    </button>
  );
}